var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock4Img9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.528564,
    y: 0.229492,
    width: 100,
    height: 100,
    rx: 20,
    fill: "url(#paint0_linear_44_3346)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4166 61.2295V40.1386H18.8758V57.553H27.9177V61.2295H14.4166ZM38.3473 61.2295H30.8707V40.1386H38.409C40.5305 40.1386 42.3567 40.5608 43.8877 41.4053C45.4188 42.2429 46.5962 43.4478 47.4201 45.02C48.2508 46.5922 48.6661 48.4733 48.6661 50.6634C48.6661 52.8604 48.2508 54.7484 47.4201 56.3275C46.5962 57.9066 45.4119 59.1183 43.8671 59.9628C42.3293 60.8073 40.4893 61.2295 38.3473 61.2295ZM35.3299 57.4088H38.1619C39.4801 57.4088 40.5889 57.1754 41.4882 56.7085C42.3945 56.2348 43.0742 55.5036 43.5273 54.515C43.9873 53.5195 44.2173 52.2356 44.2173 50.6634C44.2173 49.105 43.9873 47.8314 43.5273 46.8428C43.0742 45.8541 42.3979 45.1264 41.4985 44.6595C40.5992 44.1927 39.4904 43.9593 38.1722 43.9593H35.3299V57.4088ZM54.4152 61.2295H49.6368L56.9177 40.1386H62.6641L69.9347 61.2295H65.1563L59.8733 44.9582H59.7085L54.4152 61.2295ZM54.1165 52.9394H65.4035V56.4202H54.1165V52.9394ZM72.4732 61.2295V40.1386H80.7943C82.3939 40.1386 83.7567 40.4441 84.8827 41.0551C86.0086 41.6593 86.8668 42.5003 87.4573 43.5782C88.0546 44.6492 88.3532 45.885 88.3532 47.2856C88.3532 48.6862 88.0511 49.922 87.447 50.993C86.8428 52.064 85.9674 52.8982 84.8209 53.4955C83.6812 54.0928 82.3012 54.3914 80.681 54.3914H75.3774V50.8179H79.9601C80.8183 50.8179 81.5254 50.6703 82.0815 50.3751C82.6445 50.073 83.0633 49.6576 83.3379 49.129C83.6194 48.5935 83.7602 47.979 83.7602 47.2856C83.7602 46.5853 83.6194 45.9743 83.3379 45.4525C83.0633 44.9239 82.6445 44.5154 82.0815 44.227C81.5186 43.9318 80.8046 43.7842 79.9395 43.7842H76.9324V61.2295H72.4732Z",
    fill: "#313E4F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_3346",
    x1: 0.500122,
    y1: 0.229493,
    x2: 100.5,
    y2: 100.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99E21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock4Img9);
export default __webpack_public_path__ + "static/media/block_4_img_9.137b6c72d97b6f6a5495aa46247e1731.svg";
export { ForwardRef as ReactComponent };